import { apiClient } from "rp-components"
import { Property, PublicPropertyInfo, PropertyAccessOption } from "rp-components"

export interface PropertyService {
    getProperties(): Promise<Property[]>
    getProperty(propertyId: number): Promise<Property>
    getPublicPropertyInfo(propertyId: number): Promise<PublicPropertyInfo>
    getPropertiesAccesses(): Promise<PropertyAccessOption[]>
}

class PropertyServiceImpl implements PropertyService {
    static instance?: PropertyService = undefined

    private constructor() {}

    static getInstance(): PropertyService {
        if (PropertyServiceImpl.instance == undefined) {
            PropertyServiceImpl.instance = new PropertyServiceImpl()
        }
        return PropertyServiceImpl.instance
    }

    async getProperties(): Promise<Property[]> {
        const properties = await apiClient.get<Property[]>("/user/properties")
        return properties.sort((a, b) => (a.title > b.title ? 1 : -1))
    }

    async getProperty(propertyId: number): Promise<Property> {
        return await apiClient.get(`/properties/${propertyId}`)
    }

    async getPublicPropertyInfo(propertyId: number): Promise<PublicPropertyInfo> {
        return await apiClient.get(`/properties/${propertyId}/publicInfo`)
    }

    async getPropertiesAccesses(): Promise<PropertyAccessOption[]> {
        return await apiClient.get<PropertyAccessOption[]>("/user/properties-accesses")
    }
}

export default PropertyServiceImpl.getInstance()
